var vars = require('./core');
module.exports = vars.createClass('Line', ['getPointsAtEvent']);